import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_CUSTOMERS_DATA } from "./actionTypes";
import {
  fetchCustomersSuccess,
  fetchCustomersFailure,
} from "./actions";

function* fetchCustomersDataSaga(action) {
  try {
    const { page = 1, limit = 10 } = action.payload || {};
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const url = process.env.REACT_APP_WEB_APP_URL + `/api/web/customers?${params.toString()}`;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const payload = response.data;
    if (payload.total == null && Array.isArray(payload.data)) {
      payload.total = payload.data.length;
    }
    yield put(fetchCustomersSuccess(payload));
  } catch (error) {
    yield put(fetchCustomersFailure(error.message));
  }
}

export default function* customersSaga() {
  yield takeEvery(FETCH_CUSTOMERS_DATA, fetchCustomersDataSaga);
}
